import { useState } from 'react';
import { faqs } from '@/mocks/guagua';
import SectionHeading from '@/components/base/SectionHeading';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="px-4 md:px-6 py-12 md:py-16 bg-background-100" aria-labelledby="home-faq">
      <div className="max-w-3xl mx-auto">
        <SectionHeading
          eyebrow="FAQ"
          title="关于吃瓜，你可能想问"
          desc="几个被问得最多的问题，先替你回答一下。还有其他疑问，可以在页脚找到联系方式。"
        />
        <h2 id="home-faq" className="sr-only">
          常见问题
        </h2>
        <div className="space-y-3">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className="rounded-lg bg-background-50 border border-background-200 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  className="flex items-center justify-between gap-4 w-full px-5 py-4 text-left cursor-pointer"
                  aria-expanded={open}
                >
                  <span className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                    {item.q}
                  </span>
                  <span
                    className={`flex items-center justify-center w-7 h-7 rounded-full shrink-0 transition-colors ${
                      open ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                    }`}
                  >
                    <i className={open ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true"></i>
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5 -mt-1">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}